import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { mainNavItems, bottomNavItems, isPathActive } from './NavigationItems';
import { useOpenIdeaCount } from '../hooks/useOpenIdeaCount';

interface SidebarProps {
  onSignOut: () => void;
}

export function Sidebar({ onSignOut }: SidebarProps) {
  const location = useLocation();
  const ideaCount = useOpenIdeaCount();

  const handleKnowledgeClick = (e: React.MouseEvent) => {
    e.preventDefault();
    const event = new CustomEvent('openKnowledge');
    window.dispatchEvent(event);
  };

  const handleAvatarClick = () => {
    const event = new CustomEvent('openKnowledge');
    window.dispatchEvent(event);
  };

  return (
    <aside className="hidden lg:flex lg:flex-col lg:w-64 lg:fixed lg:inset-y-0 bg-white border-r border-gray-200">
      <div className="flex flex-col flex-1 min-h-0">
        <div className="flex items-center h-16 flex-shrink-0 px-6 border-b border-gray-200">
          <img
            src="https://cdn.prod.website-files.com/68106eab8acafbe1be69f17a/6830b7212ae8f51f0b5e545b_12ebc92fd52362293d48e2636ef26ed3_logo.svg"
            alt="Dibbi Logo"
            className="h-8"
          />
        </div>

        <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
          {mainNavItems.map((item) => {
            const isActive = isPathActive(location.pathname, item);
            const Icon = item.icon;

            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                  isActive
                    ? 'bg-[#FF6B35] text-white'
                    : 'text-gray-700 hover:bg-gray-100 hover:text-[#FF6B35]'
                }`}
              >
                <Icon className="w-5 h-5 flex-shrink-0" />
                <span>{item.label}</span>
                {item.path === '/ideeen' && ideaCount > 0 && (
                  <span className={`ml-auto text-xs font-semibold rounded-full px-2 py-0.5 min-w-[20px] text-center ${
                    isActive ? 'bg-white text-[#FF6B35]' : 'bg-[#FF6B35] text-white'
                  }`}>
                    {ideaCount}
                  </span>
                )}
              </Link>
            );
          })}
        </nav>

        <div className="flex-shrink-0 border-t border-gray-200">
          <div className="px-3 py-4 space-y-1">
            {bottomNavItems.map((item) => {
              const Icon = item.icon;

              if (item.path === '/kennisbank') {
                return (
                  <button
                    key={item.path}
                    onClick={handleKnowledgeClick}
                    className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-100 hover:text-[#FF6B35] transition-colors w-full"
                  >
                    <Icon className="w-5 h-5 flex-shrink-0" />
                    <span>{item.label}</span>
                  </button>
                );
              }

              const isActive = isPathActive(location.pathname, item);

              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-[#FF6B35] text-white'
                      : 'text-gray-700 hover:bg-gray-100 hover:text-[#FF6B35]'
                  }`}
                >
                  <Icon className="w-5 h-5 flex-shrink-0" />
                  <span>{item.label}</span>
                </Link>
              );
            })}

            <button
              onClick={onSignOut}
              className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-100 hover:text-[#FF6B35] transition-colors w-full"
            >
              <LogOut className="w-5 h-5 flex-shrink-0" />
              <span>Uitloggen</span>
            </button>
          </div>

          <div className="px-3 pb-4">
            <button
              onClick={handleAvatarClick}
              className="w-full flex items-center gap-3 p-2 rounded-lg hover:bg-gray-100 transition-colors group"
              title="Open kennisbank"
            >
              <div className="w-10 h-10 rounded-full overflow-hidden border-2 border-gray-200 group-hover:border-[#FF6B35] transition-colors flex-shrink-0">
                <img
                  src="https://s3-eu-west-1.amazonaws.com/contaqt-live/drag-drop-images/uploads/144/WDPA3_dibbi.png"
                  alt="dibbi Avatar"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-1 text-left">
                <p className="text-sm font-medium text-gray-900">dibbi</p>
                <p className="text-xs text-gray-500">Support & hulp</p>
              </div>
            </button>
          </div>
          <div className="text-[10px] text-gray-400 text-center py-2 select-none">
            v{__APP_VERSION__} · {import.meta.env.VITE_APP_ENV || (window.location.hostname.includes('test') ? 'staging' : 'live')}
          </div>
        </div>
      </div>
    </aside>
  );
}
